export const parse = rawData => ({
    serpwatcher: rawData.serpwatcher,
    serpwatcherBeta: rawData.serpwatcher_beta,
});
